import { gql } from "@apollo/client"

export const getAllSchools = gql`
  query getAllSchools(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllSchools(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        name
        email
        error {
          statusCode
          message
        }
      }
    }
  }
`
export const deleteOneSchoolMutation = gql`
  mutation deleteOneSchool($id: String!) {
    deleteOneSchool(id: $id) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`
export const getOneQuizMasterQuery = gql`
  query getQuizMaster($id: Int!) {
    getOneQuizMaster(id: $id) {
      id
      name
      ageGroupId
      dateRangeMin
      dateRangeMax
      dateRange
    }
  }
`
export const createOneSchool = gql`
  mutation createOneSchool($data: schoolInput) {
    createOneSchool(data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`
export const updateOneSchoolMutation = gql`
  mutation updateOneSchool($id: String!, $data: schoolInput) {
    updateOneSchool(id: $id, data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`
export const getAllAgeGroup = gql`
  query getAgeGroups(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllAgeGroupMasters(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        ageGroupTitle
      }
    }
  }
`
